import React, { useEffect, useState } from "react";
import "./Resume.css";

const getWindow = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return { width, height };
};

const ResumeHTML = (props) => {
  useEffect(() => {
    props.newColor("--resume-color");
  });

  const [windowDimensions, setWindowDimensions] = useState(getWindow());
  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindow());
    };
    window.addEventListener("resize", handleResize);
  }, []);

  return (
    <div className="resume-container">
      <section id="Title" className="px-5 my-5">
        <div className="container">
          <div className="row" style={{ alignItems: "center" }}>
            <div className="col-12 col-md-6 my-auto">
              {/* <h1 className="text-center pb-3">About Me</h1> */}
              <h1
                className={`display-4 ${
                  windowDimensions.width > 767
                    ? " text-end me-3"
                    : "text-center"
                }`}
              >
                Devin Wright
              </h1>
            </div>
            <div
              className={`col-12 col-md-6 text-center${
                windowDimensions.width > 767 ? " border-start" : ""
              }`}
            >
              <h2
                className={`fw-light ${
                  windowDimensions.width > 767
                    ? " text-start ms-3"
                    : "text-center"
                }`}
              >
                Full Stack Software Engineer
              </h2>
            </div>
          </div>
        </div>
      </section>

      <section id="Experience">
        <div className="container">
          <div className="row">
            <h1 className="col-12 text-center fw-semibold py-3">Experience</h1>
          </div>
          <div className="row">
            <div className="col-12 col-md-6 px-5 py-4">
              <div style={{ width: "auto", textAlign: "center" }}>
                <h3 className="ps-2 py-2 fw-semibold d-inline-block">
                  Professional Experience
                </h3>
              </div>
              <div id="Smoothstack">
                <h5 className="mb-0">
                  <span className="fw-bold">
                    <a
                      href="https://smoothstack.com/"
                      style={{ all: "unset", cursor: "pointer" }}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Smoothstack
                    </a>
                  </span>{" "}
                  |{" "}
                  <span className="fw-normal fst-italic">
                    Software Engineer - ServiceNow
                  </span>
                </h5>
                <p className="mb-1 fw-light text-uppercase">
                  July 2023 - January 2024
                </p>
                <p>
                  Developed enterprise-grade CSM service portals and custom case
                  workflows on 3-person team; managed daily standups and sprint
                  goals, leveraging Automated Test Framework to validate access
                  control logic and front end functionality.
                </p>
                <p>
                  Implemented complex Flow Designer processes and front end
                  dashboards with server- and client-side JavaScript; built
                  custom Community Questions widget with subscription and
                  filter-by-relevance features.
                </p>
              </div>
              <div id="PMGillen">
                <h5 className="mb-0">
                  <span className="fw-bold">
                    <a
                      href="https://pmgillen.com"
                      style={{ all: "unset", cursor: "pointer" }}
                      target="_blank"
                      rel="noreferrer"
                    >
                      P. M. Gillen
                    </a>
                  </span>{" "}
                  | <span className="fw-normal fst-italic">Private Tutor</span>
                </h5>
                <p className="mb-1 fw-light text-uppercase">
                  October 2017 - Present
                </p>
                <p>
                  Led tutoring and consulting sessions for groups of 25+; drove
                  improvements in college-level coursework and standardized test
                  scores, securing scholarships and admissions to elite
                  universities (Georgetown, NYU, Brown).
                </p>
              </div>
              <div id="Skadden">
                <h5 className="mb-0">
                  <span className="fw-bold">
                    Skadden, Arps, Slate, Meagher & Flom, LLP
                  </span>{" "}
                  |{" "}
                  <span className="fw-normal fst-italic">Legal Assistant</span>
                </h5>
                <p className="mb-1 fw-light text-uppercase">
                  August 2014 - September 2017
                </p>
                <p>
                  Coordinated cross-office teams on large-scale patent
                  litigation resulting in favorable client judgment; maintained
                  precision under strict deadlines across discovery, filings,
                  and attorney correspondence.
                </p>
              </div>
            </div>
            <div
              className={`col-12 col-md-6 px-5 py-4${
                windowDimensions.width > 767 ? " border-start" : ""
              }`}
            >
              <div style={{ width: "auto", textAlign: "center" }}>
                <h3 className="ps-2 py-2 fw-semibold d-inline-block">
                  Application Development
                </h3>
              </div>
              <div id="SemantiGolf">
                <h5 className="mb-0">
                  <span className="fw-bold">
                    <a
                      href="https://semantigolf.devinwrightsoftware.com/"
                      style={{ all: "unset", cursor: "pointer" }}
                      target="_blank"
                      rel="noreferrer"
                    >
                      SemantiGolf
                    </a>
                  </span>{" "}
                  |{" "}
                  <span className="fw-normal fst-italic">
                    AI-Powered Semantic Word Game
                  </span>
                </h5>
                <p className="mb-1 fw-light text-uppercase">
                  January 2026 - February 2026
                </p>
                <p>
                  Designed and shipped a full stack daily word game by
                  generating an embedding model that computes real-time cosine
                  distance similarity scores between player guesses and hidden
                  target word.
                </p>
                <p>
                  Implemented ”caddy hint” feature providing the semantic
                  midpoint word between guess and target in 30,000-word corpus
                  with sub-500 ms latency; optimized vector lookups to keep
                  response times consistent under load.
                </p>
              </div>
              <div id="DriveSundae">
                <h5 className="mb-0">
                  <span className="fw-bold">
                    <a
                      href="https://drivesundae.devinwrightsoftware.com/"
                      style={{ all: "unset", cursor: "pointer" }}
                      target="_blank"
                      rel="noreferrer"
                    >
                      DriveSundae
                    </a>
                  </span>{" "}
                  |{" "}
                  <span className="fw-normal fst-italic">
                    Full Stack Cloud File Storage Platform
                  </span>
                </h5>
                <p className="mb-1 fw-light text-uppercase">
                  November 2025 - January 2026
                </p>
                <p>
                  Architected and deployed Google Drive-inspired platform
                  supporting file loads of any type up to 10MB, featuring
                  responsive folder tree UI, breadcrumb navigation, persistent
                  dark mode, and dynamic URL routing.
                </p>
                <p>
                  Designed storage architecture using AWS S3 binary object
                  storage accessible through Drizzle ORM / SingleStore
                  relational data layer, decoupling file structure and metadata
                  to optimize scalability and query performance.
                </p>
                <p>
                  Secured application with Google OAuth to enforce user-scoped
                  access to files and folders.
                </p>
              </div>
              {/* <div id="Youneverse">
                <h5 className="mb-0">
                  <span className="fw-bold">Youneverse</span> |{" "}
                  <span className="fw-normal fst-italic">
                    ServiceNow Financial Banking Application
                  </span>
                </h5>
                <p className="mb-1 fw-light text-uppercase">
                  September 2023 - January 2024
                </p>
                <p>
                  Customized ServiceNow Vancouver release to meet
                  enterprise-level ITSM and customer service management (CSM)
                  needs.
                </p>
                <p>
                  Developed custom CSM case type and service portals for
                  internal and external users to submit, process, and track the
                  status of service requests.
                </p>
              </div> */}
              <div id="DeckReactor">
                <h5 className="mb-0">
                  <span className="fw-bold">DeckReactor</span> |{" "}
                  <span className="fw-normal fst-italic">
                    Card Collection Management Application
                  </span>
                </h5>
                <p className="mb-1 fw-light text-uppercase">November 2022</p>
                <p>
                  Integrated Scryfall API into containerized React card
                  collection app on 5-person engineering team; responsible for
                  deck/collection microservices, and designed mana symbol
                  parsing component for front end style consistency.
                </p>
                <p>
                  Implemented RTK Query with per-deck cache invalidation to sync
                  application state between microservices with MongoDB backend
                  while minimizing redundant API calls.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="Skills">
        <div className="container">
          <div className="row">
            <h1 className="col-12 text-center fw-semibold py-3">Skills</h1>
          </div>
          <div className="row">
            <div className="col-12 col-md-6 px-3 pt-4 pt-0 pt-md-4">
              <div id="Coding">
                <div className="row py-3">
                  <div className="col-12 col-md-4">
                    <h5 className="d-inline-block pe-1">Languages & Core</h5>
                  </div>
                  <div className="col-12 col-md-8">
                    <div style={{ width: "250px" }}>
                      {[...Array(10)].map((_, i) => (
                        <span key={"coding" + i}>
                          <span
                            className={`bg-accent-4 fs-6 bi bi-circle${
                              i < 9 ? "-fill" : ""
                            }`}
                          ></span>
                          &nbsp;
                        </span>
                      ))}
                      {/* <h5 className="d-inline-block mx-2 fw-bold bg-accent-4">
                        90%
                      </h5> */}
                    </div>
                    <p className="fw-light">
                      Python, JavaScript, TypeScript, HTML, CSS, SQL, PHP, Bash
                    </p>
                  </div>
                </div>
              </div>
              <div id="Front End">
                <div className="row py-3">
                  <div className="col-12 col-md-4">
                    <h5 className="d-inline-block pe-1">
                      Frameworks & Libraries
                    </h5>
                  </div>
                  <div className="col-12 col-md-8">
                    <div style={{ width: "250px" }}>
                      {[...Array(10)].map((_, i) => (
                        <span key={"frontend" + i}>
                          <span
                            className={`bg-accent-4 fs-6 bi bi-circle${
                              i < 9 ? "-fill" : ""
                            }`}
                          ></span>
                          &nbsp;
                        </span>
                      ))}
                      {/* <h5 className="d-inline-block mx-2 fw-bold bg-accent-4">
                        90%
                      </h5> */}
                    </div>
                    <p className="fw-light">
                      React, Next.js, Node.js, Django, Angular, FastAPI,
                      Tailwind, Bootstrap, Pandas, NumPy
                    </p>
                  </div>
                </div>
              </div>
              <div id="Back End">
                <div className="row py-3">
                  <div className="col-12 col-md-4">
                    <h5 className="d-inline-block pe-1">Cloud & Infra</h5>
                  </div>
                  <div className="col-12 col-md-8">
                    <div style={{ width: "250px" }}>
                      {[...Array(10)].map((_, i) => (
                        <span key={"backend" + i}>
                          <span
                            className={`bg-accent-4 fs-6 bi bi-circle${
                              i < 8 ? "-fill" : ""
                            }`}
                          ></span>
                          &nbsp;
                        </span>
                      ))}
                      {/* <h5 className="d-inline-block mx-2 fw-bold bg-accent-4">
                        80%
                      </h5> */}
                    </div>
                    <p className="fw-light">
                      AWS (EC2, Lambda, RDS, DynamoDB, S3), REST APIs, Docker,
                      Microservices, OAuth
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 px-3 pt-0 pt-md-4 pb-4">
              <div id="System Design">
                <div className="row py-3">
                  <div className="col-12 col-md-4">
                    <h5 className="d-inline-block pe-1">Databases & Tools</h5>
                  </div>
                  <div className="col-12 col-md-8">
                    <div style={{ width: "250px" }}>
                      {[...Array(10)].map((_, i) => (
                        <span key={"systemdesign" + i}>
                          <span
                            className={`bg-accent-4 fs-6 bi bi-circle${
                              i < 7 ? "-fill" : ""
                            }`}
                          ></span>
                          &nbsp;
                        </span>
                      ))}
                      {/* <h5 className="d-inline-block mx-2 fw-bold bg-accent-4">
                        70%
                      </h5> */}
                    </div>
                    <p className="fw-light">
                      PostgreSQL, MySQL, MongoDB, SingleStore, Git, Jira,
                      Confluence, Drizzle ORM
                    </p>
                  </div>
                </div>
              </div>
              <div id="Tools">
                <div className="row py-3">
                  <div className="col-12 col-md-4">
                    <h5 className="d-inline-block pe-1">AI & Data</h5>
                  </div>
                  <div className="col-12 col-md-8">
                    <div style={{ width: "250px" }}>
                      {[...Array(10)].map((_, i) => (
                        <span key={"tools" + i}>
                          <span
                            className={`bg-accent-4 fs-6 bi bi-circle${
                              i < 7 ? "-fill" : ""
                            }`}
                          ></span>
                          &nbsp;
                        </span>
                      ))}
                      {/* <h5 className="d-inline-block mx-2 fw-bold bg-accent-4">
                        80%
                      </h5> */}
                    </div>
                    <p className="fw-light">
                      Embedding Models, Natural Language Processing, Hugging
                      Face, Ollama
                    </p>
                  </div>
                </div>
              </div>
              <div id="ServiceNow">
                <div className="row py-3">
                  <div className="col-12 col-md-4">
                    <h5 className="d-inline-block pe-1">Fundamentals</h5>
                  </div>
                  <div className="col-12 col-md-8">
                    <div style={{ width: "250px" }}>
                      {[...Array(10)].map((_, i) => (
                        <span key={"servicenow" + i}>
                          <span
                            className={`bg-accent-4 fs-6 bi bi-circle${
                              i < 10 ? "-fill" : ""
                            }`}
                          ></span>
                          &nbsp;
                        </span>
                      ))}
                      {/* <h5 className="d-inline-block mx-2 fw-bold bg-accent-4">
                        90%
                      </h5> */}
                    </div>
                    <p className="fw-light">
                      Data Structures & Algorithms, Test-Driven Development,
                      System Design, Agile/Scrum
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="Education">
        <div
          className={`container${
            windowDimensions.width <= 767 ? " text-center" : ""
          }`}
        >
          <div className="row">
            <h1 className="col-12 text-center fw-semibold py-3">
              Education & Certifications
            </h1>
          </div>
          <div className="row">
            <div id="AWS SAA" className="col-12 col-md-3 px-3 py-4">
              <h5 className="mb-0 fw-bold">
                <a
                  href="https://aws.amazon.com/"
                  style={{ all: "unset", cursor: "pointer" }}
                  target="_blank"
                  rel="noreferrer"
                >
                  Amazon Web Services
                </a>
              </h5>
              <p className="mb-0 fw-normal fst-italic">
                AWS Certified Solutions Architect - Associate
              </p>
              <p className="mb-1 fw-light text-uppercase">February 2025</p>
            </div>
            <div
              id="ServiceNowCSA"
              className={`col-12 col-md-3 px-3 py-4${
                windowDimensions.width > 767 ? " border-start" : ""
              }`}
            >
              <h5 className="mb-0 fw-bold">
                <a
                  href="https://www.servicenow.com/"
                  style={{ all: "unset", cursor: "pointer" }}
                  target="_blank"
                  rel="noreferrer"
                >
                  ServiceNow
                </a>
              </h5>
              <p className="mb-0 fw-normal fst-italic">
                Certified System Administrator (CSA)
              </p>
              <p className="mb-1 fw-light text-uppercase">March 2024</p>
            </div>
            <div
              id="Columbia"
              className={`col-12 col-md-3 px-3 py-4${
                windowDimensions.width > 767 ? " border-start" : ""
              }`}
            >
              <h5 className="mb-0 fw-bold">
                <a
                  href="https://www.columbia.edu/"
                  style={{ all: "unset", cursor: "pointer" }}
                  target="_blank"
                  rel="noreferrer"
                >
                  Columbia University
                </a>
              </h5>
              <p className="mb-0 fw-normal fst-italic">
                Bachelor of Arts in Physics
              </p>
              <p className="mb-1 fw-light text-uppercase">2010 - 2014</p>
            </div>
            <div
              id="HackReactor"
              className={`col-12 col-md-3 px-3 py-4${
                windowDimensions.width > 767 ? " border-start" : ""
              }`}
            >
              <h5 className="mb-0 fw-bold">
                <a
                  href="https://www.galvanize.com/hack-reactor/"
                  style={{ all: "unset", cursor: "pointer" }}
                  target="_blank"
                  rel="noreferrer"
                >
                  Hack Reactor by Galvanize
                </a>
              </h5>
              <p className="mb-0 fw-normal fst-italic">
                Advanced Software Engineering Certificate
              </p>
              <p className="mb-1 fw-light text-uppercase">November 2022</p>
            </div>
            {/* <div
              id="Mahopac"
              className={`col-12 col-md-3 px-3 py-4${
                windowDimensions.width > 767 ? " border-start" : ""
              }`}
            >
              <h5 className="mb-0 fw-bold">
                <a
                  href="https://mhs.mahopac.org/"
                  style={{ all: "unset", cursor: "pointer" }}
                  target="_blank"
                  rel="noreferrer"
                >
                  Mahopac High School
                </a>
              </h5>
              <p className="mb-0 fw-normal fst-italic">Valedictorian</p>
              <p className="mb-1 fw-light text-uppercase">2007 - 2010</p>
            </div> */}
          </div>
        </div>
      </section>

      <section id="Portfolio">
        {/* <div className="container">
            <div className="row">
                <h1 className="col-12 text-center fw-semibold py-3">My Work</h1>
            </div>
            <div className="row">
                <div className="mx-auto col-10 row">
                    <div className="col-12 col-md-4">
                        <img className="w-100" style={{"border-radius": "12px"}} src="img/portfolio-1.jpeg" alt=""></img>
                        <h5 className="pt-3">Lorem ipsum</h5>
                        <p className="pb-4">Lorem ipsum dolor sit amet, consectetur adipiscing elit. </p>
                    </div>
                    <div className="col-12 col-md-4 square">
                        <img className="w-100" style={{"border-radius": "12px"}} src="img/portfolio-2.jpeg" alt=""></img>
                        <h5 className="pt-3">Lorem ipsum</h5>
                        <p className="pb-4">Lorem ipsum dolor sit amet, consectetur adipiscing elit. </p>
                    </div>
                    <div className="col-12 col-md-4 square">
                        <img className="w-100" style={{"border-radius": "12px"}} src="img/portfolio-3.jpeg" alt=""></img>
                        <h5 className="pt-3">Lorem ipsum</h5>
                        <p className="pb-4">Lorem ipsum dolor sit amet, consectetur adipiscing elit. </p>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="mx-auto col-10 row">
                    <div className="col-12 col-md-4 square">
                        <img className="w-100" style={{"border-radius": "12px"}} src="img/portfolio-4.jpeg" alt=""></img>
                        <h5 className="pt-4">Lorem ipsum</h5>
                        <p className="pb-4">Lorem ipsum dolor sit amet, consectetur adipiscing elit. </p>
                    </div>
                    <div className="col-12 col-md-4 square">
                        <img className="w-100" style={{"border-radius": "12px"}} src="img/portfolio-5.jpeg" alt=""></img>
                        <h5 className="pt-4">Lorem ipsum</h5>
                        <p className="pb-4">Lorem ipsum dolor sit amet, consectetur adipiscing elit. </p>
                    </div>
                    <div className="col-12 col-md-4 square">
                        <img className="w-100" style={{"border-radius": "12px"}} src="img/portfolio-6.jpeg" alt=""></img>
                        <h5 className="pt-4">Lorem ipsum</h5>
                        <p className="pb-4">Lorem ipsum dolor sit amet, consectetur adipiscing elit. </p>
                    </div>
                </div>
            </div>
        </div> */}
      </section>
    </div>
  );
};

ResumeHTML.propTypes = {};

ResumeHTML.defaultProps = {};

export default ResumeHTML;
